interface StarRatingProps {
  /** 평점(0~5). null/undefined면 렌더하지 않는다. */
  rating?: number | null | undefined;
  /** 리뷰 수. 있으면 "(123)" 형태로 덧붙인다. */
  count?: number | null | undefined;
}

/**
 * 컴팩트 평점 표시.
 * DESIGN.md v3: 클린 블루 accent, 그림자/레드/문자 아이콘 없음. 평점이 없으면 null.
 */
export function StarRating({ rating, count }: StarRatingProps) {
  if (rating == null) return null;

  const label =
    count != null
      ? `평점 ${rating.toFixed(1)}점, 리뷰 ${count}개`
      : `평점 ${rating.toFixed(1)}점`;

  return (
    <span
      className="inline-flex shrink-0 items-center gap-0.5 text-tag font-semibold text-primary"
      aria-label={label}
    >
      <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" className="fill-current">
        <path d="M6 1.2 7.35 4.1l3.15.38-2.33 2.15.62 3.12L6 8.18 3.21 9.75l.62-3.12L1.5 4.48l3.15-.38L6 1.2Z" />
      </svg>
      <span aria-hidden="true">{rating.toFixed(1)}</span>
      {count != null && (
        <span aria-hidden="true" className="font-medium text-ink-muted">
          ({count})
        </span>
      )}
    </span>
  );
}
